import { Box } from "@mui/material"
import React from "react"
import Text from "src/components/Text"
import { useUserFerroBoost } from "src/state/xFer/hooks"
import boostPools from "src/constants/boostPools"
import { calculateAccruedFer } from "src/pages/Stake/helpers"
import VaultRow from "./VaultRow"
import CustomCard from "src/components/CustomCard"
import { FER } from "src/constants"
import FerroPriceText from "src/components/FerroPriceText"
import Button from "src/components/Button"
import { formatUnits } from "ethers/lib/utils"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { useIsMobile } from "src/hooks/useIsMobile"
import HarvestOptionModal from "src/components/HarvestOptionModal"
import { useBoolean } from "src/hooks/useBoolean"
import DepositModal from "src/pages/Stake/components/DepositModal"
import { useClaimVaultReward } from "src/hooks/useClaimReward"
import useXFerState from "src/pages/Stake/hooks/useXFerState"
import { HarvestMode } from "src/state/xFer/types"

const VaultSection = () => {
  const isMobile = useIsMobile()
  const { boostData } = useUserFerroBoost()
  const { openedDepositModal } = useXFerState()
  const { claim } = useClaimVaultReward()
  const [showModal, openModal, closeModal] = useBoolean(false)

  return (
    <Box mt={3}>
      <CustomCard variant="black50" p={2}>
        <Text size="small">Total Pending Rewards in Vaults</Text>
        <Box
          display={isMobile ? "block" : "flex"}
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <Box>
            <Text bold my={0.5}>{`${FER.symbol} ${formatNumber(
              formatUnits(boostData.pendingFer, FER.decimals),
              2,
              6,
            )}`}</Text>
            <FerroPriceText amount={boostData.pendingFer} />
          </Box>
          <Button
            size="small"
            width={isMobile ? "100%" : "auto"}
            mt={isMobile ? 1 : 0}
            onClick={openModal}
            disabled={boostData.pendingFer.eq(0)}
          >
            Harvest All
          </Button>
        </Box>
      </CustomCard>
      {boostPools.map((pool) => (
        <VaultRow
          key={pool.pid}
          accruedFer={calculateAccruedFer(
            pool.pid,
            boostData.pendingFer,
            boostData.stakes,
          )}
          {...pool}
        />
      ))}
      <HarvestOptionModal
        open={showModal}
        onClose={closeModal}
        harvest={claim}
        harvestMode={HarvestMode.Vault}
        harvestAmount={boostData.pendingFer}
      />
      {openedDepositModal && (
        <DepositModal
          defaultSelectedPool={openedDepositModal.defaultSelectedPool}
        />
      )}
    </Box>
  )
}

export default VaultSection
